/**
 * /baseinfo/shop/parse/shop-code
 */
import { useFetch } from "../../../hooks";
export var useApiBaseinfoShopParseShopCode = function useApiBaseinfoShopParseShopCode() {
  var _useFetch = useFetch(),
    post = _useFetch.post;
  var DEFAULT_PARSEURL = '/baseinfo/shop/parse/shop-code';
  return function () {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_PARSEURL;
    var data = arguments.length > 1 ? arguments[1] : undefined;
    return post({
      url: url === '' ? DEFAULT_PARSEURL : url,
      method: 'post',
      data: data
    }).then(function (data) {
      return data.data;
    }).catch(function (error) {
      return error.response.data;
    });
  };
};